__webpack_require__.p = "https://sto.baza.education/packs/";